import { useSyncExternalStore } from "react";
import {
  subscribeServerError,
  getServerErrorSnapshot,
  clearServerError
} from "@/api/httpClient";

/**
 * Hook to read the global server error state from httpClient.
 *
 * When any API call returns a 5xx, httpClient sets the error flag instead
 * of hard-redirecting to /learning/server-error. Components that call this
 * hook will re-render and can display the error page in-place — keeping
 * the current URL so the student can refresh to retry.
 *
 * Returns:
 *  - hasError: whether a 5xx has occurred
 *  - status: the HTTP status code (500, 502, etc.)
 *  - clear: function to dismiss the error (e.g. "Return to dashboard")
 */
export function useServerError() {
  const snapshot = useSyncExternalStore(
    subscribeServerError,
    getServerErrorSnapshot
  );

  return {
    hasError: snapshot.hasError,
    status: snapshot.status,
    clear: clearServerError
  };
}
